async function validateEmail(email: string): Promise<number> {

  try {

    const timeout = new Promise<number>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 3000),
    );
    const url = `https://ruuf-backend.online/auth/send-destination-to-ruuf`;

    const response = await Promise.race([
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // credentials: "include",
        body: JSON.stringify({ destination: email }),
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    const data = await response.json();

    if (response.status === 200) {
      console.log("Email is valid");
      console.log(data.success);
      return 0; // Email is valid
    } else if (response.status === 500) {
      console.error("Invalid email");
      console.log(data.message);
      return 1; // Invalid email
    } else {
      throw new Error("Unexpected response status");
    }
  } catch (error) {
    console.error("Error validating email:", error);
    return -1; // Error validating email
  }
}

export default validateEmail;
